
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.8 5.444v2.334h4.8v3.889H4.8V14L0 9.722l4.8-4.278zM16 4.278L11.2 0v2.333H6.4v3.89h4.8v2.333L16 4.278z","fill":"#065AA1"}})])
          )
        }
      }
    